import React, { FC } from "react";
import classNames from "classnames";
import { useTranslations } from "next-intl";

import { CustomRadioButton } from "@/components/common";
import { CardIcon, ClickIcon, PaymeIcon } from "@/components/assets/icons";
import { IPaymentProvider } from "@/types/apiResponse.types";

type Props = {
  item: IPaymentProvider;
  isSelected: boolean;
  handleSelectMethod: (id: string) => void;
};

const PaymentItem: FC<Props> = ({
  item: { id },
  isSelected,
  handleSelectMethod,
}) => {
  const t = useTranslations();

  const renderIcon = (id: string) => {
    switch (id) {
      case "payme":
        return <PaymeIcon />;
      case "click":
        return <ClickIcon />;
      case "GeorgianBank":
        // return <BogIcon />;
        return <CardIcon />;
      default:
        return null;
    }
  };

  return (
    <div
      className={classNames(
        "flex h-[50px] cursor-pointer items-center justify-between rounded-[99px] border border-transparent p-[5px] pr-[10px]",
        {
          "primary-border bg-[#f9f9f9]": isSelected,
          shadow: !isSelected,
        },
      )}
      onClick={() => handleSelectMethod(id)}
    >
      <div className="flex flex-row items-center gap-[7px]">
        <span className="ml-[10px] mr-[10px]">{renderIcon(id)}</span>
        <div className="flex flex-col">
          <p className="text-nowrap text-xs font-medium">
            {id === "click" ? id : id === "GeorgianBank" ? t("bog") : ""}
          </p>
        </div>
      </div>
      <CustomRadioButton
        id={id}
        name={id}
        primaryColor
        selected={isSelected}
        onChange={() => {}}
      />
    </div>
  );
};

export default PaymentItem;
